import {Box, Typography} from "@mui/material";
import { Button } from '../Button';
import warningInfoIcon from '../../assets/images/warningInfoIcon.svg'
import { ModalComponent } from '../ModalComponent';

const MessageContentStyles = {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    gap: '18px',
    padding: '12px 16px',
    borderRadius: '0px 8px 8px 0px',
    borderLeft: '2px solid #FDB022',
    background: '#FFF9EC',
};

const staticContent = {
  cancelHeader: 'Are you sure you want to cancel this reservation?',
  discardHeader: 'Are you sure you want to discard changes?',
  cancelMessage: `If you cancel this reservation, you may not be able to secure the same quantity of doses for delivery in the same timeframe again.
                  This operation cannot be undone.`,
  discardMessage: `Your reservation will revert to its previous state and any changes will be lost.
                   This operation cannot be undone.`
}

const ConfirmationModal = ({ closeModal, openModal, contentType, handleConfirm }) => {
  const getContentBasedOnType = (contentType) => {
    const isCancel = contentType === "cancel";
    return {
      headerText: isCancel
        ? staticContent.cancelHeader
        : staticContent.discardHeader,
      messageText: isCancel
        ? staticContent.cancelMessage
        : staticContent.discardMessage,
      noButtonText: isCancel ? "No, keep this reservation" : "No, keep editing",
      yesButtonText: isCancel
        ? "Yes, cancel this reservation"
        : "Yes, discard changes",
    };
  }

  const { headerText, messageText, noButtonText, yesButtonText } = getContentBasedOnType(contentType);

  const modalContent = () => { 
    return (
    <>
        <Box sx={MessageContentStyles}>
            <img src={warningInfoIcon} alt="info icon" width="32" height="32" />
            <Box data-testid="messageContent" display="flex" flexDirection="column" alignItems="flex-start" gap="10px" flex="1 0 0">
                <Typography fontFamily="Aeonik Regular" fontSize="16px" fontWeight="700">
                  {headerText}
                </Typography>
                <Typography fontFamily="Aeonik Regular" textAlign="left" sx={{ whiteSpace: 'pre-line' }}>
                  {messageText}
                </Typography>
            </Box>
        </Box>
        <Box data-testid="buttonGroup" display="flex" justifyContent="center" gap="10px" width="100%">
            <Button
                buttonType='mds-secondary'
                sx={{ padding: "16px 24px", textTransform: "none" }}
                onClick={closeModal}
            >
                <Typography fontFamily="Aeonik Regular" fontSize="14px" fontWeight="700">
                  {noButtonText}
                </Typography>
            </Button>
            <Button buttonType='mds-primary' sx={{ padding: "16px 24px", textTransform: "none" }} onClick={() => handleConfirm()}>
                <Typography fontFamily="Aeonik Regular" fontSize="14px" fontWeight="700">
                  {yesButtonText}
                </Typography>
            </Button>
        </Box>
    
    </>
  )}

  return (
    <ModalComponent 
      title={contentType === 'cancel' ? 'Cancel reservation' : 'Discard changes'}
      openModal={openModal}
      closeModalHandler={closeModal}
      style={{ 
        maxWidth: '521px',
        width: 'auto',
        padding: '24px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '23px',
        '#titleContainer':{
            marginLeft: '0px',
            padding: '5px'
        },
    }}
    modalContent={modalContent()}
    />
  )
}

export default ConfirmationModal